import type React from "react";

export function JetsPickupIcon(): React.ReactNode {
  return (
    <svg
      width="64"
      height="64"
      viewBox="0 0 500 500"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Pickup</title>
      <g transform="matrix(0.5938860774040222, 0, 0, 0.5938860774040222, -96.70851898193362, -32.63583755493164)">
        <g>
          <polygon
            points="182.13 540.18 176.71 446.48 284.08 420.43 284.08 328.88 575.09 260.67 861.06 336.45 879 425.06 977.56 448.63 977.56 567.49 566.5 717.25 182.13 540.18"
            strokeWidth={0}
            fill="rgb(255,255,255)"
          />
          <path
            d="m566.5,617.88c-1.93,0-3.86-.39-5.63-1.18l-384.15-170.22c-4.82-2.14-7.6-6.76-6.93-11.52.67-4.76,4.64-8.63,9.91-9.64l112.35-21.54,283.42-54.34c1.94-.37,3.95-.33,5.86.11l409.22,95.34c5.29,1.23,9.09,5.35,9.44,10.22.35,4.87-2.85,9.38-7.92,11.2l-420.83,150.77c-1.52.55-3.12.81-4.72.81Zm-346.08-177.27l346.63,153.6,379.94-136.12-369.17-86.01-357.41,68.53Z"
            strokeWidth={0}
            fill="rgb(0, 146, 69)"
          />
          <path
            d="m566.5,730.82c-1.93,0-3.86-.39-5.64-1.18l-384.15-170.22c-4.31-1.91-7.03-5.83-7.03-10.12v-112.94c0-6.24,5.67-11.3,12.67-11.3s12.67,5.06,12.67,11.3v105.94l372.04,164.85,407.62-146.03v-105.3c0-6.24,5.67-11.3,12.67-11.3s12.67,5.06,12.67,11.3v112.94c0,4.61-3.15,8.76-7.95,10.48l-420.83,150.77c-1.52.54-3.12.81-4.72.81Z"
            strokeWidth={0}
            fill="rgb(0, 146, 69)"
          />
          <path
            d="m566.5,730.82c-7,0-12.67-5.06-12.67-11.3v-107.56c0-6.24,5.67-11.3,12.67-11.3s12.67,5.06,12.67,11.3v107.56c0,6.24-5.67,11.3-12.67,11.3Z"
            strokeWidth={0}
            fill="rgb(0, 146, 69)"
          />
        </g>
        <path
          d="m566.32,540.18c104.23-40.39,208.45-80.79,312.68-121.18-100.33-24.67-200.67-49.33-301-74-95.33,19.67-190.67,39.33-286,59"
          strokeWidth={0}
          fill="rgb(255,255,255)"
        />
      </g>
      <g transform="matrix(0.5938860774040222, 0, 0, 0.5938860774040222, -96.70851898193362, -32.63583755493164)">
        <path
          d="m565.93,467.82c-1.4,0-2.79-.32-4.07-.96l-277.77-137.99c-3.49-1.73-5.5-5.48-5.01-9.34.48-3.86,3.36-7,7.16-7.82l286.16-61.51c1.4-.3,2.85-.27,4.24.09l295.9,77.29c3.82,1,6.58,4.34,6.83,8.28.25,3.94-2.06,7.6-5.73,9.08l-304.29,122.22c-1.1.44-2.26.66-3.41.66Zm-250.24-143.7l250.64,124.51,274.72-110.34-266.93-69.72-258.43,55.55Z"
          fill="rgb(0, 146, 69)"
          stroke="rgb(0, 146, 69)"
          strokeWidth={3}
          strokeMiterlimit={10}
        />
        <path
          d="m565.93,559.37c-1.4,0-2.79-.32-4.07-.96l-277.77-137.99c-3.11-1.55-5.08-4.72-5.08-8.2v-91.55c0-5.06,4.1-9.16,9.16-9.16s9.16,4.1,9.16,9.16v85.88l269.01,133.63,294.74-118.38v-85.36c0-5.06,4.1-9.16,9.16-9.16s9.16,4.1,9.16,9.16v91.55c0,3.74-2.27,7.1-5.75,8.5l-304.29,122.22c-1.1.44-2.26.66-3.41.66Z"
          fill="rgb(0, 146, 69)"
          stroke="rgb(0, 146, 69)"
          strokeWidth={3}
          strokeMiterlimit={10}
        />
        <path
          d="m565.93,559.37c-5.06,0-9.16-4.1-9.16-9.16v-87.19c0-5.06,4.1-9.16,9.16-9.16s9.16,4.1,9.16,9.16v87.19c0,5.06-4.1,9.16-9.16,9.16Z"
          fill="rgb(0, 146, 69)"
          stroke="rgb(0, 146, 69)"
          strokeWidth={3}
          strokeMiterlimit={10}
        />
      </g>
    </svg>
  );
}
